import TimeRecorderGPSPage from './TimeRecorderGPSPage';

export default TimeRecorderGPSPage;
